import {alertActions} from '@core/store/alertReducer';
import Alert from '@shared/components/alert';
import Loader from '@shared/components/loader/index';
import {RootState, dispatch} from '@store';
import {useSelector} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';

import AppRoutes from './routes';
import './App.scss';
import './utils/main.scss';

export default function App() {
  const {
    loader: {isAppLoading},
    alert: {message, isOpen, alertType},
  } = useSelector((state: RootState) => state);

  const alertContent = () => (
    <div className='alert-content'>
      {alertType !== 'success' ? (
        <span className='fw-6'>Error</span>
      ) : (
        <span className='fw-6'>Success</span>
      )}
      <span>{message || 'Something went wrong'}</span>
    </div>
  );

  if (isOpen) {
    setTimeout(() => {
      dispatch(alertActions.closeAlertMsg());
    }, 5000);
  }
  return (
    <>
      <div className='main-container'>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </div>
      {isAppLoading && (
        <div className='app-loader'>
          <Loader />
        </div>
      )}
      {isOpen && (
        <Alert
          closeFn={() => {
            dispatch(alertActions.closeAlertMsg());
          }}
          variant='filled'
          showIcon={false}
          content={alertContent()}
          isCloseVisible
          toastType={alertType}
          id={alertType}
          dataTestId='test-toast'
        />
      )}
    </>
  );
}
